import React from 'react';
import { Route } from 'react-router-dom';
import TerminateInactiveTag from 'modules/TerminateInactiveTag/TerminateInactiveTag';
import { TERMINATE_INACTIVE_TAG_EXACT, TERMINATE_INACTIVE_TAG } from './paths';
export default function TerminateInactiveTagRoutes() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: TERMINATE_INACTIVE_TAG_EXACT
  }, /*#__PURE__*/React.createElement(TerminateInactiveTag, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: TERMINATE_INACTIVE_TAG(':tagNumber(\\d+)')
  }, /*#__PURE__*/React.createElement(TerminateInactiveTag, null)));
}